import { useEffect } from "react"
import { Grid } from "../components"
import { Navbar, Footer } from "../layouts"
import Whistleblower from "../components/whistleblower"




const WhistleblowingStatement = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/>
        <Whistleblower/>
        <Footer/>
        </>

    )
}

export default WhistleblowingStatement